import React from 'react';
import { FormField, Input } from 'semantic-ui-react';
import PropTypes from 'prop-types';

function FileUploader({ input: { value, onChange, ...input }, meta, ...rest }) {
  const errorContent = meta.touched && !!meta.error && meta.error;

  return (
    <FormField error={errorContent}>
      <Input
        {...input}
        {...rest}
        type="file"
        onChange={({ target }) => onChange(target.files)}
      />
    </FormField>
  );
}

FileUploader.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
};

export default FileUploader;
